var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnselectedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "#7E716D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.582 7.91671C12.582 7.59454 12.3209 7.33337 11.9987 7.33337C11.6765 7.33337 11.4154 7.59454 11.4154 7.91671V11.4167H7.91536C7.5932 11.4167 7.33203 11.6779 7.33203 12C7.33203 12.3222 7.5932 12.5834 7.91536 12.5834H11.4154V16.0834C11.4154 16.4055 11.6765 16.6667 11.9987 16.6667C12.3209 16.6667 12.582 16.4055 12.582 16.0834V12.5834H16.082C16.4042 12.5834 16.6654 12.3222 16.6654 12C16.6654 11.6779 16.4042 11.4167 16.082 11.4167H12.582V7.91671Z",
    fill: "#7E716D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnselectedIcon);
export default __webpack_public_path__ + "static/media/unselected-icon.24ac386d5c9d6b6bba0f3ce4388de288.svg";
export { ForwardRef as ReactComponent };